import * as React from 'react';
import type {
  ScheduledReportType,
} from 'contracts/scheduled-reports';
import { api, handleApiError } from 'services/api';

type Payload = {
  type: ScheduledReportType
  params: Record<string, unknown>
}

export const useCreateScheduledReport = () => {
  const createScheduledReport = React.useCallback(async (payload: Payload) => {
    try {
      await api.post('/scheduled-reports', payload);
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    createScheduledReport,
  };
};